<google-map #agentsMap height="100%" width="100%"
            [center]="center"
            [zoom]="zoom"
            [options]="mapOptions">

  <ng-container *ngFor="let agentMarker of agentMarkers">

    <map-marker #marker="mapMarker"
                [position]="agentMarker.position"
                [options]="agentMarker.options"
                (mapMouseover)="openInfoWindow(marker, agentInfoWindow)"
                (mapMouseout)="closeInfoWindows(agentInfoWindow)"
                (mapClick)="onAgentClick(agentMarker)">

    </map-marker>
    <map-info-window #agentInfoWindow="mapInfoWindow">
      <div class="flex-column">
        <span class="br-body-2">{{agentMarker.agent.user.firstName}} {{agentMarker.agent.user.lastName}}</span>
        <div *ngIf="agentMarker.agent.externalId" class="layout-row layout-align-start-center margin-top-5">
          <span class="br-body-2" translate>External ID</span>:
          <span class="margin-left-5 br-body-2">{{agentMarker.agent.externalId}}</span>
        </div>
        <div *ngIf="!!agentMarker.agent.agentBranches?.length"
             class="layout-row layout-align-start-center margin-top-5">
          <bringoz-icon iconName="branch" fill="#7E7E7E" classSize="md"></bringoz-icon>
          <branches-indicator class="margin-left-5" [branches]="agentMarker.agent.agentBranches"></branches-indicator>
        </div>
        <div *ngIf="agentMarker.agent.tags" class="margin-top-5">
          <app-bringoz-tags [tags]="agentMarker.agent.tags"
                            backgroundColor="transparent"
                            color="#7E7E7E"
                            maxTags="1">
          </app-bringoz-tags>
        </div>
      </div>
    </map-info-window>
  </ng-container>

  <ng-container *ngFor="let accountMarker of accountMarkers">

    <map-marker #marker="mapMarker"
                [position]="accountMarker.position"
                [options]="accountMarker.options"
                (mapMouseover)="openInfoWindow(marker, accountInfoWindow)"
                (mapMouseout)="closeInfoWindows(accountInfoWindow)"
                (mapClick)="onAgentClick(accountMarker)">

    </map-marker>
    <map-info-window #accountInfoWindow="mapInfoWindow">
      <div class="flex-column">
        <span class="br-body-2">{{accountMarker.account.name}}</span>
      </div>
    </map-info-window>
  </ng-container>

  <ng-container *ngFor="let depotMarker of depotMarkers">

    <map-marker #marker="mapMarker"
                [position]="depotMarker.position"
                [options]="depotMarker.options"
                (mapMouseover)="openInfoWindow(marker, depotInfoWindow)"
                (mapMouseout)="closeInfoWindows(depotInfoWindow)"
                (mapClick)="onAgentClick(depotMarker)">

    </map-marker>
    <map-info-window #depotInfoWindow="mapInfoWindow">
      <div class="flex-column">
        <span class="br-body-2">{{depotMarker.depot.name}}</span>
      </div>
    </map-info-window>
  </ng-container>
</google-map>
